export default __webpack_public_path__ + "static/media/user-check.250c60c4.svg";